import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import productimg from "../../images/Icons/products.png";
import useLogout from "../Auth/useLogout";
import { useDispatch, useSelector } from "react-redux";
import { fetchTransporterProduct } from "../../redux/slice/transporterProduct";
import { fetchTransporterOrder } from "../../redux/slice/transporterOrder";
import TransporterEnquiry from "./TransporterEnquiry";
import TransporterOrder from "./TransporterOrder";
import TransporterProductList from "./TransporterProductList";
import TransporterBelt from "./TransporterBelt";
import TransporterVehicle from "./TransporterVehicle";

export default function TransporterProduct() {
  const logout = useLogout();
  const dispatch = useDispatch();
  const [dataLoading, setDataLoading] = useState(false);

  const { transporterProductData, isError } = useSelector(
    (state) => state.transporterProduct
  );
  const { transporterOrderData, isError1 = isError } = useSelector(
    (state) => state.transporterOrder
  );

  useEffect(() => {
    const fetchData = async () => {
      if (!isError && !isError1) {
        setDataLoading(true);
        try {
          await dispatch(fetchTransporterProduct(logout));
          await dispatch(fetchTransporterOrder(logout));
        } catch (error) {
        } finally {
          setDataLoading(false);
        }
      }
    };
    fetchData();
  }, [dispatch, isError, isError1, logout]);

  const location = useLocation();

  const getModeFromPath = (path) => {
    if (path.includes("/transporter/enquiry")) return "enquiry";
    if (path.includes("/transporter/orders")) return "order";
    if (path.includes("/transporter/products")) return "product";
    if (path.includes("/transporter/belts")) return "belt";
    if (path.includes("/transporter/vehicles")) return "vehicle";
    return "enquiry";
  };

  const mode = getModeFromPath(location.pathname);

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row-layout mrb1">
            <div className="row-hd-txt">
              <div className="row-hd-txt-left">
                <img src={productimg} alt="" />
                <h5>
                  {mode === "order"
                    ? "Order"
                    : mode === "product"
                      ? "Product"
                      : mode === "belt"
                        ? "Belt"
                        : mode === "vehicle"
                          ? "Vehicle"
                          : "Enquiry"}{" "}
                  List
                </h5>
              </div>
              <div className="rfq-txt-right">
                <div className="d-flex gap-2">
                  <Link
                    to="/transporter/enquiry"
                    className={`btn btn-sm ${mode === "enquiry" ? "btn-danger" : "btn-outline-danger"
                      }`}
                  >
                    Enquiry List
                  </Link>
                  <Link
                    to="/transporter/orders"
                    className={`btn btn-sm ${mode === "order" ? "btn-danger" : "btn-outline-danger"
                      }`}
                  >
                    Order List
                  </Link>
                  <Link
                    to="/transporter/products"
                    className={`btn btn-sm ${mode === "product" ? "btn-danger" : "btn-outline-danger"
                      }`}
                  >
                    Product List
                  </Link>
                  <Link
                    to="/transporter/belts"
                    className={`btn btn-sm ${mode === "belt" ? "btn-danger" : "btn-outline-danger"
                      }`}
                  >
                    Belt List
                  </Link>
                  <Link
                    to="/transporter/vehicles"
                    className={`btn btn-sm ${mode === "vehicle" ? "btn-danger" : "btn-outline-danger"
                      }`}
                  >
                    Vehicle List
                  </Link>
                </div>
              </div>
            </div>
            <p className="order-note">
              <span>Note - </span>
              You can select the option between Order list, Enquiry list. Add
              your belt, products, and vehicle for furthure process.
            </p>

            {mode === "order" ? (
              <TransporterOrder
                orderList={transporterOrderData || []}
                dataLoading={dataLoading}
              />
            ) : mode === "product" ? (
              <TransporterProductList />
            ) : mode === "belt" ? (
              <TransporterBelt />
            ) : mode === "vehicle" ? (
              <TransporterVehicle />
            ) : (
              <TransporterEnquiry
                enquiryList={transporterProductData || []}
                dataLoading={dataLoading}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
